import src from "IMAGE";
export default { src, width: 140, height: 140 }
